import { dateToString } from '../helper/dates';
import Grid from './Grid';
import { DateInput, GroupInput, Input, TimeInput } from './Input';

const yup = require('../interface/yup-br');

export const GridDiario = ({ url, GridHeaders, LineDataPrint, GridTitle = 'Diário de Bordo', ...rest }) => {
    let _GridHeaders = [
        { title: 'Data', field: 'data', sort: true, className: 'w-1/12 text-center pl-1' },
        { title: 'Data Alerta', field: 'dataAlerta', sort: true, className: 'w-1/12 text-center pl-1' },
        { title: 'Hora Alerta', field: 'horaAlerta', sort: true, className: 'w-1/12 text-center pl-1' },
        { title: 'Registro', field: 'registro', sort: true, className: 'w-8/12 text-left pl-1' },
        { title: 'URL', field: 'url', sort: true, className: 'w-2/12 text-left pl-1' },
    ];
    let _LineDataPrint = (data) => {
        return [
            dateToString(data?.data),
            dateToString(data?.dataAlerta),
            data.horaAlerta,
            data.registro,
            data.url
        ];
    };
    return (
        <Grid
            url={url}
            {...rest}
            disableModal={true}
            GridHeaders={GridHeaders ?? _GridHeaders}
            GridTitle={GridTitle}
            LineDataPrint={LineDataPrint ?? _LineDataPrint}
            onRenderForm={() => {
                return (
                    <div className="w-full">
                        <GroupInput>
                            <DateInput name="data" label="Data" className={"w-44"} />
                            <DateInput name="dataAlerta" label="Data alerta" className={"w-44"} />
                            <TimeInput name="horaAlerta" label="Hora alerta" className={'w-44'} />
                        </GroupInput>
                        <Input name="registro" label="Registro" />
                        <Input type="url" name="url" label="URL" />
                    </div>
                );
            }}
            validationSchema={() => {
                return yup.object().shape({
                    data: yup.string(),
                    registro: yup.string(),
                });
            }}
        />
    );
};
